import { render, staticRenderFns } from "./record51talk.vue?vue&type=template&id=63066d0c&scoped=true"
import script from "./record51talk.vue?vue&type=script&lang=js"
export * from "./record51talk.vue?vue&type=script&lang=js"
import style0 from "./record51talk.vue?vue&type=style&index=0&id=63066d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63066d0c",
  null
  
)

export default component.exports